import { FiltersMap } from '@wix/bex-core';
import { ToolbarCollectionState } from '../../state';
import { CustomFieldModal } from '../CustomFieldModal';
import { CustomColumnsFull } from '../CustomColumns';
import { ArchiveFieldModal } from '../CustomFieldsPanel/ArchiveFieldModal';
import { CustomColumnsAddCustomFieldCTAButton } from '../CustomFieldsPanel/CustomColumnsAddCustomFieldCTAButton';
import { CustomColumnsEditCustomFieldCTAButton } from '../CustomFieldsPanel/CustomColumnsEditCustomFieldCTAButton';
import { CollectionDataExtensionState } from './CollectionDataExtensionState';

const setDataExtensionOnTable = <T, F extends FiltersMap>(
  toolbar: ToolbarCollectionState<T, F>,
) => {
  toolbar.collectionDataExtension ??= new CollectionDataExtensionState<T, F>({
    toolbar,
    container: toolbar.container,
    DataExtension,
  });
};

export const DataExtension = {
  setDataExtensionOnTable,
  CustomFieldModal,
  ArchiveFieldModal,
  CustomColumns: CustomColumnsFull,
  CustomColumnsAddCustomFieldCTAButton,
  CustomColumnsEditCustomFieldCTAButton,
};

export type DataExtensionType = typeof DataExtension;
